export const BUILD_VERSION = '1793789396';
